<template>
  <div :class="['col log-entry-item d-flex flex-column', hasBorder ? 'has-border' : '']">
    <div class="log-entry-heading d-flex">
      <icon class="mr-2 d-inline-block" type="grip-vertical"/>
      <div class="uppercase d-inline-block">{{ translatedLabel }}</div>
    </div>
    <div class="right-text">
      <slot/>
      {{ values }}
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue";

export default {
  name: "LogEntryInformationPart",
  components: {Icon},
  props: {
    hasBorder: {type: Boolean, default: false},
    label: {type: String, required: true},
    values: {type: [String, Number], default: ''}
  },
  computed: {
    translatedLabel() {
      const lowerCaseLabel = this.label.toLowerCase();
      return this.$t('pipeline.' + lowerCaseLabel);
    }
  }
}
</script>

<style lang="scss" scoped>
.log-entry-item {
  color: rgba(255,255,255,0.8);
  min-height: 80px;
  line-height: 1.1rem;

  .right-text {
    //word-break: break-all;
    align-self: flex-end;
    margin-top: auto;
    text-align: right;
  }

  &.has-border {
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }
}
</style>